/* eslint-disable security/detect-object-injection */
export const JobTypeMap = {
    CONTRACTOR: 'Freelancer',
    FULL_TIME: 'Vollzeit',
    INTERN: 'Praktikum',
    PART_TIME: 'Teilzeit',
    TEMPORARY: 'Aushilfe'
};

/**
 * The `useJobsCard` hook provides formatted employment type information for job cards.
 * This hook takes an employment type key and returns a formatted object containing the corresponding display text.
 * It serves as a utility for transforming employment type keys into user-friendly German text representations.
 *
 * @param employmentType The employment type key that corresponds to a value in JobTypeMap.
 * @returns An object containing the formatted employment type display text.
 *
 * @example
 * ```tsx
 * const jobCardData = useJobsCard('FULL_TIME');
 * console.log(jobCardData.type); // Output: 'Vollzeit'
 *
 * const contractorData = useJobsCard('CONTRACTOR');
 * console.log(contractorData.type); // Output: 'Freelancer'
 * ```
 */
export const useJobsCard = (employmentType: keyof typeof JobTypeMap) => ({type: JobTypeMap[employmentType]});